import { Airport, CountryItem, PageResult, TideClientConfig } from "../types";
import { get } from "./common-client";

const ENDPOINT = "/api/web/search";
const ENDPOINT_COUNTRIES = `${ENDPOINT}/countries`;
const ENDPOINT_AIRPORTS = `${ENDPOINT}/airports`;

/**
 * api/search/countries
 * Gets all Countries
 * @param config
 * @param signal
 * @returns OK if succeeded.
 */
export const getCountries = (
  config: TideClientConfig,
  signal?: AbortSignal
): Promise<PageResult<CountryItem>> => {
  const url = `${config.host}${ENDPOINT_COUNTRIES}`;
  const apiKey = config.apiKey;

  return get(url, apiKey, config.token, signal, true);
};

export const getAirports = (
  config: TideClientConfig,
  signal?: AbortSignal
): Promise<Airport[]> => {
  const url = `${config.host}${ENDPOINT_AIRPORTS}`;
  const apiKey = config.apiKey;

  return get(url, apiKey, config.token, signal, true);
};
